<template>
  <b-overlay :show="loading" variant="transparent" opacity="0.99" blur="5px" rounded="sm">
    <template #overlay>
      <div class="text-center">
        <b-icon-controller font-scale="3" animation="cylon" />
        <p>กรุณารอสักครู่...</p>
      </div>
    </template>

    <div class="card mb-1">
      <div class="card-body">
        <h4 class="mb-1"><span class="text-muted">AutoPeer Mbet /</span> <strong>รายการถอน</strong></h4>
        <div class="row">
          <div class="col-md-2">
            <label>Username</label>
            <input v-model="filters.username" type="text" class="form-control" placeholder="Username" @keyup.enter="fetchWithdrawals" />
          </div>
          <div class="col-md-2">
            <label>สถานะ</label>
            <b-form-select v-model="filters.status" :options="statusOptions" />
          </div>
          <div class="col-md-2">
            <label>วันที่เริ่มต้น</label>
            <flat-pickr v-model="filters.startDate" class="form-control" :config="{ enableTime: true, dateFormat: 'Y-m-d H:i', time_24hr: true }" />
          </div>
          <div class="col-md-2">
            <label>วันที่สิ้นสุด</label>
            <flat-pickr v-model="filters.endDate" class="form-control" :config="{ enableTime: true, dateFormat: 'Y-m-d H:i', time_24hr: true }" />
          </div>
          <div class="col-md-2 d-flex align-items-end">
            <button class="btn btn-gradient-dark" @click="fetchWithdrawals">
              <feather-icon icon="SearchIcon" /> ค้นหา
            </button>
          </div>
        </div>
      </div>
    </div>

    <b-card no-body>
      <b-table small striped hover responsive show-empty :items="items" :fields="fields" :per-page="perPage" class="position-relative">
        <template #cell(index)="data">{{ perPage * (currentPage - 1) + (data.index + 1) }}</template>
        <template #cell(amount)="data">{{ formatNum(data.item.amount) }}</template>
        <template #cell(status)="data">
          <span class="badge" :class="statusClass(data.item.status)">{{ data.item.status }}</span>
        </template>
        <template #cell(createdAt)="data">{{ formatDate(data.item.createdAt) }}</template>
        <template #empty>
          <div class="p-2 text-center"><img src="/box.png" alt="empty" height="40" /> ไม่พบข้อมูล</div>
        </template>
      </b-table>

      <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
        <b-form-group label="Per Page" label-cols="8" label-align="left" label-size="sm" class="text-nowrap mb-md-0 mr-1">
          <b-form-select v-model="perPage" size="sm" :options="[10,20,50,100]" @change="fetchWithdrawals" />
        </b-form-group>
        <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" first-number last-number class="mb-0" @input="fetchWithdrawals">
          <template #prev-text><feather-icon icon="ChevronLeftIcon" size="18" /></template>
          <template #next-text><feather-icon icon="ChevronRightIcon" size="18" /></template>
        </b-pagination>
      </b-card-body>
    </b-card>
  </b-overlay>
</template>

<script>
import moment from 'moment-timezone'
import flatPickr from 'vue-flatpickr-component'
import { BOverlay, BIconController, BCard, BCardBody, BTable, BFormGroup, BFormSelect, BPagination } from 'bootstrap-vue'

export default {
  components: { flatPickr, BOverlay, BIconController, BCard, BCardBody, BTable, BFormGroup, BFormSelect, BPagination },
  data() {
    return {
      loading: false,
      items: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 20,
      filters: {
        username: '',
        status: '',
        startDate: moment().tz('Asia/Bangkok').format('YYYY-MM-DD 00:00'),
        endDate: moment().tz('Asia/Bangkok').format('YYYY-MM-DD 23:59'),
      },
      statusOptions: [
        { value: '', text: 'ทั้งหมด' },
        { value: 'processing', text: 'กำลังดำเนินการ' },
        { value: 'success', text: 'สำเร็จ' },
        { value: 'cancelled', text: 'ยกเลิก' },
        { value: 'timeout', text: 'หมดเวลา' },
      ],
      fields: [
        { key: 'index', label: 'No.' },
        { key: 'username', label: 'ยูสเซอร์เนม' },
        { key: 'amount', label: 'จำนวนเงิน', sortable: true },
        { key: 'status', label: 'สถานะ' },
        { key: 'providerOrderId', label: 'Provider Ref' },
        { key: 'refNo', label: 'Ref No' },
        { key: 'externalRef', label: 'External Ref' },
        { key: 'createdAt', label: 'วันที่ทำรายการ', sortable: true },
      ],
    }
  },
  mounted() { this.fetchWithdrawals() },
  methods: {
    async fetchWithdrawals() {
      this.loading = true
      try {
        const { data: res } = await this.$http.get('/autopeer-mbet/withdrawals', {
          params: {
            page: this.currentPage, limit: this.perPage,
            username: this.filters.username || undefined,
            status: this.filters.status || undefined,
            startDate: this.filters.startDate ? moment(this.filters.startDate).toISOString() : undefined,
            endDate: this.filters.endDate ? moment(this.filters.endDate).toISOString() : undefined,
          },
        })
        const d = res.data || res
        this.items = d.list || []
        this.totalRows = d.pagination?.total || this.items.length
      } catch (err) {
        console.error(err)
        this.$swal({ icon: 'error', title: 'เกิดข้อผิดพลาด', text: 'ไม่สามารถโหลดรายการถอนได้' })
      } finally { this.loading = false }
    },
    formatNum(v) { return Number(v || 0).toLocaleString(undefined, { minimumFractionDigits: 2 }) },
    formatDate(v) { return v ? moment(v).tz('Asia/Bangkok').format('DD/MM/YYYY HH:mm:ss') : '-' },
    statusClass(s) {
      if (s === 'success') return 'badge-success'
      if (s === 'cancelled' || s === 'timeout') return 'badge-danger'
      return 'badge-info'
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
